import axios from 'axios';
import config from '../../../config';

const domain = config.api_domain.domain

const LoaderUtilsService = async (endpoint) => {
    try {
        const url = (`${domain}/admin/${endpoint}`)
        const res = await axios.get(url)
        return res.data.body
        
    } catch (error) {
        console.error(error);
        return null;
    }
}

export default LoaderUtilsService